
// export const contract = "0xdAC17F958D2ee523a2206206994597C13D831ec7"
export const contract = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"

  export const BUSD: { [key: string]: string } = {
    "1": "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
    "3": "0xD848eD7f625165D7fFa9e3B3b0661d6074902FD4",
    "56": "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    "97": "0x10249e900b919fdee9e2ed38b4cd83c4df857254",
    "137": "0xdab529f40e671a1d4bf91361c21bf9f0c9712ab7",
    "80001": "",
  };


  export const topAddresses = [
  "0x00000000219ab540356cBB839Cbe05303d7705Fa",
  "0x0716a17FBAeE714f1E6aB0f9d59edbC5f09815C0",
  "0x1b3cB81E51011b549d78bf720b0d924ac763A7C2",
  "0x8103683202aa8DA10536036EDef04CDd865C225E",
  "0x2B6eD29A95753C3Ad948348e3e7b1A251080Ffb9",
  "0x189B9cBd4AfF470aF2C0102f365FC1823d857965",
  "0x195B91CCEbD51aa61D851fE531f5612Dea4EfBfD",
  "0x756D64Dc5eDb56740fC617628dC832DDBCfd373c",
  "0x176F3DAb24a159341c0509bB36B833E7fdd0a132",
  "0x73AF3bcf944a6559933396c1577B257e2054D935"
  
  ]